import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=61483648&scoped=true&"
import script from "./BookingInfo.vue?vue&type=script&lang=js&"
export * from "./BookingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=61483648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61483648",
  null
  
)

export default component.exports